import { render, staticRenderFns } from "./OrderSystem.vue?vue&type=template&id=11977e98&scoped=true"
import script from "./OrderSystem.vue?vue&type=script&lang=js"
export * from "./OrderSystem.vue?vue&type=script&lang=js"
import style0 from "./OrderSystem.vue?vue&type=style&index=0&id=11977e98&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11977e98",
  null
  
)

export default component.exports